import { atom } from 'jotai';


const sidepanelAtom = atom({});

export { sidepanelAtom };